<template>
<div class="container-fluid">
	<page-loading v-if="!data_loaded" />

	<div v-else class="row">
	    <div class="col-12">
			<h1>Trashed Check-Ins</h1>
		</div>
		<div class="col-12">
			<div class="card table-responsive">
    			<table class="checkins-table table mb-0">
    				<thead>
    					<th></th>
    					<th>Client</th>
    					<th>Check-In</th>
    					<th>By</th>
    					<th>Deleted</th>
    					<th></th>
    				</thead>

    				<tr v-for="checkin in checkins">
    					<td>
    						<input type="checkbox" :value="checkin.id" v-model="ids">
    					</td>
    					<td>
    						<span v-html="checkin.client ? checkin.client.name : '<em>unknown client</em>'" />
    					</td>
    					<td>
    						<span class="badge" :class="checkin.checkin_type ? checkin.checkin_type.css_class_name : 'badge-light'" v-html="checkin.checkin_type ? checkin.checkin_type.label : 'unknown'" /> with
							<span v-html="checkin.physician ? checkin.physician.display_name : '<em>unknown physician</em>'" />
    					</td>
    					<td>
    						<span v-html="checkin.checkin_user ? checkin.checkin_user.display_name : '<em>unknown user</em>'" class="text-gray-700" />
    					</td>
    					<td>
    						<span v-html="moment(checkin.deleted_at).format('MMM D, YYYY')" class="text-gray-500" />
    					</td>
    					<td>
    						<button class="btn btn-light btn-sm" v-tooltip.bottom="'Put Back'" @click="restoreItems(checkin.id)"><i class="fal fa-trash-undo text-gray-500"></i></button>
    						<button class="btn btn-light btn-sm" v-tooltip.bottom="'Permadelete'" @click="deleteItems(checkin.id)"><i class="fal fa-times-circle text-gray-500"></i></button>
    					</td>
    				</tr>

    				<tr>
    					<td>
    						<input type="checkbox" @click="toggleAll()">
    					</td>
    					<td colspan="5">
    						<button class="btn btn-primary" :disabled="ids.length < 1" @click="restoreItems()"><i class="fal fa-trash-undo mr-1"></i>Restore Items</button>
    						<button class="btn btn-primary" :disabled="ids.length < 1" @click="deleteItems()"><i class="fal fa-times-circle mr-1"></i>Permanently Delete</button>
    					</td>
    				</tr>
    			</table>
    		</div>
        </div>
    </div>
</div>	

</template>

<script>
	import BreadcrumbsManager from '../../../helpers/BreadcrumbManager';

	export default {
		mixins: [BreadcrumbsManager],

		data() {
			return {
				data_loaded: false,
				checkins: null,

				ids: [],
			}
		},

		created() {
			this.fetchTrashedCheckins();
		},

		activated() {
			this.setBreadcrumbs([
	            { text: 'Home', to: { name: 'home' } },
	            { text: 'Trashed Items', to: { name: 'admin.trashed.checkins'} },
	            { text: 'Check-Ins', to: { name: ''} },
        	]);
		},


		methods: {
			deleteItems(id) {
				let ids = id ? [id] : this.ids;
				Swal.fire({
					title: 'Are you sure?',
					text: 'You will *really* not be able to recover the item(s)',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Delete',
					cancelButtonText: 'Keep',
					animation: false,
				}).then((result) => {
					if (result.value) {
						this.data_loaded = false;
						axios.post('/api/checkins/trashed/delete', { ids: ids }).then(({data}) => {
							Swal.fire({
			                    toast: true,
			                    position: 'top-end',
			                    showConfirmButton: false,
			                    timer: 3000,
			                    icon: 'success',
			                    title: 'Items deleted',
			                });
			                this.fetchTrashedCheckins();					
						});
					}
				});
			},

			fetchTrashedCheckins() {
				axios.get('/api/checkins/trashed').then(({data}) => {
					this.checkins = data;
					this.data_loaded = true;
				})
			},

			restoreItems(id) {
				let ids = id ? [id] : this.ids;
				this.data_loaded = false;
				axios.post('/api/checkins/trashed/restore', { ids: ids }).then(({data}) => {
					Swal.fire({
	                    toast: true,
	                    position: 'top-end',
	                    showConfirmButton: false,
	                    timer: 3000,
	                    icon: 'success',
	                    title: 'Items restored',
	                });
	                this.fetchTrashedCheckins();					
				});
			},

			toggleAll() {
				if (this.ids.length > 0) {
					this.ids = [];
				} else {
					this.ids = this.checkins.map(checkin => checkin.id);
				}
			}
		},
	}
</script>